import { parseFormInput } from 'transfix-ui/components/CurrencyInput'
import { array, object, string, number } from 'yup'
import { FORMATTED_PHONE_REGEX } from 'utils/formatPhone'
import { ALPHANUMERIC_REGEX } from 'constants/regex'

export const postSchema = object({
  origin: object({
    city: string().required(),
    state: string().required(),
  }),
  destination: object({
    city: string().required(),
    state: string().required(),
  }),
})

export const MAX_RATE = 99999
export const MAX_RATE_MESSAGE = `List Rate must not exceed $${MAX_RATE}.`

export const commonPostSchema = object().shape({
  rate: string()
    .required('Rate is required')
    .test('max', MAX_RATE_MESSAGE, value => {
      const parsedValue = parseFormInput(value)

      return parsedValue ? MAX_RATE >= parsedValue : true
    }),
  commentsTwo: string().max(70, 'Comments can have a max of 70 chars'),
})

export const activePostsObjectSchema = array().of(postSchema)
export const activePostsSchema = array().min(1).max(8)

export const rateCheckSchema = (shipperRate: number) => {
  const lowerBound = shipperRate / 2
  const upperBound = shipperRate * 2

  return number()
    .positive('Please enter a valid number amount')
    .min(lowerBound, 'Rate is less than 50% of customer rate')
    .max(upperBound, 'Rate is more than 200% of customer rate')
}

export const phoneSchema = string().matches(FORMATTED_PHONE_REGEX, 'Phone number is not valid')

export const vinCheckSchema = string()
  .min(4, 'VIN must be at least 4 characters long.')
  .max(6)
  .matches(ALPHANUMERIC_REGEX, 'VIN must be alphanumeric.')

export const emailCheckSchema = string().email('Please enter a valid email address')

const carrier = ['amount', 'carrierApplicationId', 'carrierContactPhone', 'carrierContactName']
const assignDriver = ['truckLocation', 'etaDate', 'etaTime']
const assignSelected = [...assignDriver, 'selectedDriver']
const assignNewDefault = [
  ...assignDriver,
  'newDriver',
  'userType',
  'firstName',
  'lastName',
  'cellPhone',
]

const ownerOperatorRequired = ['role', 'email']

const callbackReminder = ['carrierContactName', 'carrierContactPhone']

const callbackCustom = [...callbackReminder, 'callbackDate', 'callbackTime']

export const requiredFields = {
  carrier,
  assignSelected,
  assignNewDefault,
  ownerOperatorRequired,
  callbackReminder,
  callbackCustom,
}
